<app-loading-spinner
  *ngIf="isLoading"
  [loadingTitle]="'global.loading-spinner-fetch-title'"
  [loadingSubtitle]="'global.loading-spinner-fetch-subtitle'"
  [overlay]="true"
></app-loading-spinner>

<div class="outer-container">
  <br/>
  <div class="row">
    <div class="filter">
      <form [formGroup]="form">
        <div class="row row-cols-auto">
          <div class="col-2-spacing">
            <div class="form-group">
              <label for="seriesFilter">{{ 'global.series' | transloco }}</label>
              <ng-select
                [searchable]="true"
                [clearable]="false"
                notFoundText="{{ 'global.dropdown-not-found-text' | transloco }}"
                [hideSelected]="true"
                [items]="seriesList"
                bindLabel="brName"
                bindValue="value"
                formControlName="seriesFilter"
                placeholder="{{ 'components.footer.all' | transloco }}"
              >
                <ng-template ng-option-tmp let-item="item">
                  {{ item.value === '' ? ('components.footer.all' | transloco) : item.brName }}
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  {{ item.value === '' ? ('components.footer.all' | transloco) : item.brName }}
                </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="col-2-spacing">
            <div class="form-group">
              <label for="vinFilter">VIN</label>
              <input
                type="text"
                autocomplete="off"
                class="form-control search"
                formControlName="vinFilter"
                id="vinFilter"
                placeholder="{{ 'modules.data-management.filter.input-placeholder' | transloco }}"
              />
            </div>
          </div>
          <div class="col-2-spacing">
            <div class="form-group">
              <label for="appointmentDateFilter">{{ 'modules.admin-section.preflash-monitoring.appointment-date' | transloco }}</label>
              <div class="input-group preflash-date-picker">
                <input
                  class="form-control dp"
                  placeholder="{{ 'global.datepicker-placeholder' | transloco }}"
                  id="appointmentDateFilter"
                  name="dp"
                  formControlName="appointmentDateFilter"
                  ngbDatepicker
                  #appointmentDatePicker="ngbDatepicker"
                  readonly
                  (click)="appointmentDatePicker.open()"
                />
                <button
                  *ngIf="form.get('appointmentDateFilter')?.value"
                  type="button"
                  class="preflash-date-clear"
                  [title]="'modules.admin-section.preflash-monitoring.clear-date' | transloco"
                  [attr.aria-label]="'modules.admin-section.preflash-monitoring.clear-date' | transloco"
                  (click)="$event.preventDefault(); $event.stopPropagation(); clearDateFilter('appointmentDateFilter')"
                >
                  <i class="bi bi-x-lg"></i>
                </button>
                <i class="bi bi-calendar3" (click)="appointmentDatePicker.open()"></i>
              </div>
            </div>
          </div>
          <div class="col-2-spacing">
            <div class="form-group">
              <label for="calculationTimeFilter">{{ 'modules.admin-section.preflash-monitoring.calculation-time' | transloco }}</label>
              <div class="input-group preflash-date-picker">
                <input
                  class="form-control dp"
                  placeholder="{{ 'global.datepicker-placeholder' | transloco }}"
                  id="calculationTimeFilter"
                  name="dp"
                  formControlName="calculationTimeFilter"
                  ngbDatepicker
                  #calculationTimePicker="ngbDatepicker"
                  readonly
                  (click)="calculationTimePicker.open()"
                />
                <button
                  *ngIf="form.get('calculationTimeFilter')?.value"
                  type="button"
                  class="preflash-date-clear"
                  [title]="'modules.admin-section.preflash-monitoring.clear-date' | transloco"
                  [attr.aria-label]="'modules.admin-section.preflash-monitoring.clear-date' | transloco"
                  (click)="$event.preventDefault(); $event.stopPropagation(); clearDateFilter('calculationTimeFilter')"
                >
                  <i class="bi bi-x-lg"></i>
                </button>
                <i class="bi bi-calendar3" (click)="calculationTimePicker.open()"></i>
              </div>
            </div>
          </div>
          <div class="col-2-spacing">
            <div class="form-group">
              <label for="statusFilter">{{ 'global.status' | transloco }}</label>
              <ng-select
                [searchable]="false"
                [clearable]="false"
                [items]="statusList"
                bindLabel="label"
                bindValue="value"
                formControlName="statusFilter"
                placeholder="{{ 'components.footer.all' | transloco }}"
              >
                <ng-template ng-option-tmp let-item="item">
                  {{ item.value === '' ? ('components.footer.all' | transloco) : item.label }}
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  {{ item.value === '' ? ('components.footer.all' | transloco) : item.label }}
                </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="col-2-spacing">
            <div class="form-group">
              <label for="systemFilter">{{ 'modules.admin-section.preflash-monitoring.system' | transloco }}</label>
              <ng-select
                [searchable]="false"
                [clearable]="false"
                [items]="systemList"
                bindLabel="label"
                bindValue="value"
                formControlName="systemFilter"
                placeholder="{{ 'components.footer.all' | transloco }}"
              >
                <ng-template ng-option-tmp let-item="item">
                  {{ item.value === '' ? ('components.footer.all' | transloco) : item.label }}
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  {{ item.value === '' ? ('components.footer.all' | transloco) : item.label }}
                </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="col-2-spacing">
            <div class="form-group">
              <label for="sdpFilter">SDP</label>
              <input
                type="text"
                autocomplete="off"
                class="form-control search"
                formControlName="sdpFilter"
                id="sdpFilter"
                placeholder="{{ 'modules.data-management.filter.input-placeholder' | transloco }}"
              />
            </div>
          </div>
          <div class="col-2-spacing">
            <div class="form-group">
              <label for="vp5VersionFilter">VP5-Version</label>
              <input
                type="text"
                autocomplete="off"
                class="form-control search"
                formControlName="vp5VersionFilter"
                id="vp5VersionFilter"
                placeholder="{{ 'modules.data-management.filter.input-placeholder' | transloco }}"
              />
            </div>
          </div>
          <div class="col-2-spacing">
            <div class="form-group">
              <label for="asTactFilter">AS-Tact</label>
              <input
                type="text"
                autocomplete="off"
                class="form-control search"
                formControlName="asTactFilter"
                id="asTactFilter"
                placeholder="{{ 'modules.data-management.filter.input-placeholder' | transloco }}"
              />
            </div>
          </div>
          <div class="col">
            <div class="button-area-search">
              <button type="button" class="btn btn-primary">
                {{ 'modules.data-management.filter.btn-search' | transloco }}
              </button>
              <button type="button" class="btn btn-secondary">
                {{ 'modules.data-management.filter.btn-reset' | transloco }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <br/>
  <div class="row">
    <div class="col-12">
      <div class="vus-container">
        <ngx-datatable
          #dataTable
          class="material datatable-scrollable"
          [columnMode]="'flex'"
          [headerHeight]="56"
          rowHeight="auto"
          [scrollbarH]="false"
          [scrollbarV]="false"
          [rows]="preflashData"
          [externalPaging]="true"
          [count]="totalItems"
          [offset]="currentPage - 1"
          [limit]="pageSize"
          [footerHeight]="56"
        >
          <ngx-datatable-column
            [cellClass]="'text-right'"
            name="{{ 'global.series' | transloco }}"
            [flexGrow]="2"
            [resizeable]="false"
            prop="series"
            [sortable]="true"
          >
          </ngx-datatable-column>
          <ngx-datatable-column
              [cellClass]="'text-right'"
              name="VIN"
              [flexGrow]="4"
              [resizeable]="false"
              prop="vin"
              [sortable]="true"
            >
          </ngx-datatable-column>
          <ngx-datatable-column
            [cellClass]="'text-right'"
            name="{{ 'modules.admin-section.preflash-monitoring.appointment-date' | transloco }}"
            [flexGrow]="3"
            [resizeable]="false"
            prop="appointment_date"
            [sortable]="true"
          >
            <ng-template
                let-value="value"
                let-row="row"
                ngx-datatable-cell-template
              >
                <span *ngIf="value">{{ value | date : "dd.MM.yyyy HH:mm:ss" }}</span>
            </ng-template>
            <ng-template
              ngx-datatable-header-template
              let-column="column"
            >
              <span
                class="local-time-subheader"
                [attr.data-subtitle]="'global.local-time' | transloco"
              >
                {{ column.name }}
              </span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            [cellClass]="'text-right'"
            name="{{ 'modules.admin-section.preflash-monitoring.calculation-time' | transloco }}"
            [flexGrow]="3"
            [resizeable]="false"
            prop="calculation_time"
            [sortable]="true"
          >
            <ng-template
              let-value="value"
              let-row="row"
              ngx-datatable-cell-template
            >
              <span *ngIf="value">{{ value | date : "dd.MM.yyyy HH:mm:ss" }}</span>
              <span *ngIf="!value">-</span>
            </ng-template>
            <ng-template
              ngx-datatable-header-template
              let-column="column"
            >
              <span
                class="local-time-subheader"
                [attr.data-subtitle]="'global.local-time' | transloco"
              >
                {{ column.name }}
              </span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            [cellClass]="'text-right'"
            name="Status"
            [flexGrow]="2"
            [resizeable]="false"
            prop="status"
            [sortable]="true"
          >
            <ng-template
              let-value="value"
              let-row="row"
              ngx-datatable-cell-template
            >
              <span
                *ngIf="value"
                [ngClass]="'status-' + value"
                [title]="value === 'error' ? row.error_message : ''"
              >
                {{ 'modules.admin-section.preflash-monitoring.status.' + value | transloco }}
              </span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            [cellClass]="'text-right'"
            name="System"
            [flexGrow]="2"
            [resizeable]="false"
            prop="system"
            [sortable]="true"
          >
          </ngx-datatable-column>
          <ngx-datatable-column
            [cellClass]="'text-right'"
            name="SDP"
            [flexGrow]="4"
            [resizeable]="false"
            prop="sdp"
            [sortable]="true"
          >
          </ngx-datatable-column>   
          <ngx-datatable-column
            [cellClass]="'text-right'"
            name="VP5-Version"
            [flexGrow]="2"
            [resizeable]="false"
            prop="vp5_version"
            [sortable]="true"
          >
          </ngx-datatable-column>
          <ngx-datatable-column
            [cellClass]="'text-right'"
            name="AS-Tact"
            [flexGrow]="4"
            [resizeable]="false"
            prop="as_tact"
            [sortable]="true"
          >
          </ngx-datatable-column>
          <ngx-datatable-column
            [cellClass]="'text-right'"
            name="{{ 'global.actions' | transloco }}"
            [sortable]="false"
            [flexGrow]="3"
            [resizeable]="false"
          >
            <ng-template 
              let-row="row" 
              let-rowIndex="rowIndex" 
              let-expanded="expanded" 
              ngx-datatable-cell-template
            >
              <div class="action-column">
                <span
                  style="cursor: pointer;"
                  *ngIf="row.status !== 'pending' && row.status !== 'queued'"
                  (click)="openCalculationDetails(row)"
                >
                  <i class="bi bi-search"></i>
                </span>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template>
              <div class="col-8">
                <datatable-pager
                  [pagerLeftArrowIcon]="'datatable-icon-left'"
                  [pagerRightArrowIcon]="'datatable-icon-right'"
                  [pagerPreviousIcon]="'datatable-icon-prev'"
                  [pagerNextIcon]="'datatable-icon-skip'"
                  [count]="totalItems"
                  [page]="currentPage"
                  [size]="pageSize"
                  (change)="setPage($event)"
                ></datatable-pager>
              </div>
              <div class="col-4 page-result-section server-side">
                <span class="float-end">
                  <span class="result-text">{{ 'components.footer.result-per-page' | transloco }}</span>
                  <span class="result-value" [ngClass]="{ active: pageSize === 10 }" (click)="setPageSize(10)">10</span>|
                  <span class="result-value margin-override" [ngClass]="{ active: pageSize === 30 }" (click)="setPageSize(30)">30</span>|
                  <span class="result-value" [ngClass]="{ active: pageSize === 100 }" (click)="setPageSize(100)">100</span>
                  <span>
                    {{ 'components.footer.files' | transloco }}: {{ pageStart }} - {{ pageEnd }}
                  </span>
                  <span>{{ 'components.footer.of' | transloco }} {{ totalItems }}</span>
                </span>
              </div>
            </ng-template>
          </ngx-datatable-footer>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>

<ng-template #calculationDetailsModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h5 class="modal-title">{{ 'modules.admin-section.preflash-monitoring.modal-title' | transloco }}</h5>
  </div>
  <div class="modal-body" *ngIf="selectedCalculationResult">
    <div class="preflash-store-grid">
      <div class="ecu-section">
        <table class="table table-dark table-bordered ecu-table">
          <thead>
            <tr>
              <th>{{ 'modules.admin-section.preflash-monitoring.ecu' | transloco }}</th>
              <th>{{ 'modules.admin-section.preflash-monitoring.flash-requirement' | transloco }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let ecu of selectedCalculationResult.ecuList">
              <td>{{ ecu.Diogenes_Name }}</td>
              <td>
                {{ (ecu.Flash === 1 ?
                    'modules.admin-section.preflash-monitoring.yes' :
                    'modules.admin-section.preflash-monitoring.no') | transloco }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="details-section">
        <div class="detail-row">
          <label>{{ 'modules.admin-section.preflash-monitoring.vin' | transloco }}</label>
          <span>{{ selectedCalculationResult.vin }}</span>
        </div>
        <div class="detail-row">
          <label>{{ 'modules.admin-section.preflash-monitoring.appointment' | transloco }}</label>
          <span>{{ selectedCalculationResult.appointment_date | date : 'dd.MM.yy HH:mm:ss' }}</span>
        </div>
        <div class="detail-row">
          <label>{{ 'modules.admin-section.preflash-monitoring.sdp' | transloco }}</label>
          <span>{{ selectedCalculationResult.sdp }}</span>
        </div>
        <div class="detail-row">
          <label>{{ 'modules.admin-section.preflash-monitoring.vp5' | transloco }}</label>
          <span>{{ selectedCalculationResult.vp5_version }}</span>
        </div>
        <div class="detail-row">
          <label>{{ 'modules.admin-section.preflash-monitoring.as-tact' | transloco }}</label>
          <span>{{ selectedCalculationResult.as_tact }}</span>
        </div>
        <div class="detail-row">
          <label>{{ 'modules.admin-section.preflash-monitoring.error' | transloco }}</label>
          <!-- TODO: Display actual error message once finalized -->
          <span>{{ '-' }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" style="margin-right: 8px;" class="btn btn-secondary" (click)="d()">
      {{ 'global.cancel' | transloco }}
    </button>
  </div>
</ng-template>
